// config

export const app_build_version_id_zzyourmap = 'f_build2026-04-28f'; // UNIQUE ID FOR LAST CHANGES TO THIS APP - FOR FASIER TRACKING OF COMMITS AND BUILDS

export const _zzyourmap_config = {};
_zzyourmap_config.ENV_EXTERNAL = 'UNKNOWN';
// _zzyourmap_config.WEBSITE_URL_PREFIX = 'http://localhost/projekti-gitphp/temp-ym-backend';
// _zzyourmap_config.BACKEND_URL_PREFIX = 'http://localhost/projekti-gitphp/temp-ym-backend';

// _zzyourmap_config.BACKEND_URL_PREFIX = 'https://ymdemo2.applabz.work';
// _zzyourmap_config.BACKEND_URL_PREFIX = 'https://ymdemo2.applabz.work';

// for localhost backend
// _zzyourmap_config.BACKEND_URL_PREFIX = 'http://localhost/projekti-gitphp/temp-ym-backend';
// _zzyourmap_config.BACKEND_API_URL_PREFIX = 'http://localhost/projekti-gitphp/temp-ym-backend';
// _zzyourmap_config.BACKEND_API_ENDPOINT_PREFIX = '/api-v1.php';

// for real backend demo
_zzyourmap_config.BACKEND_URL_PREFIX = 'https://ymdemo2.applabz.work';
_zzyourmap_config.BACKEND_API_URL_PREFIX = 'https://ymdemo2.applabz.work';
_zzyourmap_config.BACKEND_API_ENDPOINT_PREFIX = '/api/v1/q';

if (window.yourmap_config_external && window.yourmap_config_external.BACKEND_API_URL_PREFIX && typeof window.yourmap_config_external.BACKEND_API_URL_PREFIX === 'string') {
  _zzyourmap_config.BACKEND_URL_PREFIX = window.yourmap_config_external.BACKEND_API_URL_PREFIX;
  _zzyourmap_config.BACKEND_API_URL_PREFIX = window.yourmap_config_external.BACKEND_API_URL_PREFIX;
}
if (window.yourmap_config_external && window.yourmap_config_external.BACKEND_API_URL_PREFIX && typeof window.yourmap_config_external.ENV_EXTERNAL === 'string') {
  _zzyourmap_config.ENV_EXTERNAL = window.yourmap_config_external.ENV_EXTERNAL;
}

// _zzyourmap_config.img_placeholder_url_full = 'https://ymdemo2.applabz.work/test-assets/no-image-available.jpg';
_zzyourmap_config.img_placeholder_url_full = 'https://yourmap.rs/test-assets/no-image-available.jpg';
// _zzyourmap_config.header_default_img_url_full = 'https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg';
_zzyourmap_config.header_default_img_url_full = 'https://yourmap.rs/test-assets/ym-header-image-default1.jpg';
_zzyourmap_config.logo_img_url_full = 'https://yourmap.rs/static/ym-assets/yourmap-logo.png';
// _zzyourmap_config.map_checkboard_img_url_full = "https://yourmap.rs/static/ym-assets/ym-checkboard-256x256px.png";
_zzyourmap_config.demo_map_img_url_full = 'https://yourmap.rs/test-assets/ym-demo-mapa.jpg';

